import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_12: FaireProductEntity = {
  token: "toysmith-12",
  type: "product",
  name: "Toysmith 37-Piece Marble Run",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/85918193606a1dc21c3b6b965abc33f2303a12ad82ae1d63caa2b8ec00a48dd0.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 15,
  msrpDollars: 30,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
